if (!customElements.get('rj-product-assistance')) {
  customElements.define('rj-product-assistance', class extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.ready = true;
        this.addEventListener('click', event => {
          if (event.target.closest('a[data-product-inquiry], a[data-product-bespoke]')) this.updateInquiry();
        });
      }
      this.mountQuickAdvice();
      this.updateInquiry();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const info = this.closest('product-info');
          if (String(event.data.sectionId) === String(info?.dataset.section)) {
            this.updateInquiry(event.data.variant);
          }
        });
      }
    }
    disconnectedCallback() {
      this.unsubscribeVariant?.();
      this.unsubscribeVariant = null;
    }
    mountQuickAdvice() {
      const info = this.closest('product-info');
      const form = info?.querySelector('product-form');
      const source = this.querySelector('a[data-product-inquiry]');
      if (!form || !source) return;
      let quick = info.querySelector('[data-rj-quick-advice]');
      if (!quick) {
        quick = document.createElement('div');
        quick.dataset.rjQuickAdvice = '';
        quick.className = 'rj-quick-advice';
        const ask = document.createElement('a');
        ask.dataset.rjQuickInquiry = '';
        ask.textContent = 'Spørg Jakob om dit valg';
        ask.href = source.href;
        ask.addEventListener('click', () => this.updateInquiry());
        const call = document.createElement('a');
        call.href = 'tel:+4531355152';
        call.textContent = 'Ring til Jakob';
        quick.append(ask, call);
        form.after(quick);
      }
      this.quickInquiry = quick.querySelector('[data-rj-quick-inquiry]');
    }
    updateInquiry(selectedVariant) {
      const link = this.querySelector('a[data-product-inquiry]');
      if (!link) return;
      const info = this.closest('product-info');
      const id = info?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      const variant = selectedVariant || variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', variant.title);
      link.href = url.toString();
      if (this.quickInquiry) this.quickInquiry.href = link.href;
      const bespoke = this.querySelector('a[data-product-bespoke]');
      if (bespoke) {
        const bespokeUrl = new URL(bespoke.href);
        bespokeUrl.searchParams.set('variant', variant.title);
        bespoke.href = bespokeUrl.toString();
      }
    }
  });
}

if (!document.getElementById('rj-quick-advice-style')) {
  const style = document.createElement('style');
  style.id = 'rj-quick-advice-style';
  style.textContent = '.rj-quick-advice{display:flex;flex-wrap:wrap;justify-content:space-between;gap:0 20px;margin:6px 0 16px;border-bottom:1px solid #d7d0c3}.rj-quick-advice a{display:inline-flex;align-items:center;min-height:44px;color:inherit;font-size:13px;line-height:1.5;text-decoration:underline;text-underline-offset:4px}.rj-quick-advice a:focus-visible{outline:2px solid currentColor;outline-offset:3px}@media(max-width:380px){.rj-quick-advice{gap:0 12px}.rj-quick-advice a{font-size:12px}}';
  document.head.append(style);
}
